import { action } from 'satcheljs';
export default action('REMOVE_MESSAGE_AD_LIST', function () {
    return {};
});
//# sourceMappingURL=removeMessageAdList.js.map